import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './carousel-item.component.scss';
var CarouselItem = /** @class */ (function (_super) {
    tslib_1.__extends(CarouselItem, _super);
    function CarouselItem(element) {
        return _super.call(this, element) || this;
    }
    CarouselItem.prototype.init = function () { };
    ;
    CarouselItem.prototype.bindEvents = function () { };
    ;
    return CarouselItem;
}(Base));
export { CarouselItem };



//////////////////
// WEBPACK FOOTER
// ./components/carousel-item/carousel-item.component.ts
// module id = 196
// module chunks = 0